.container {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  svg {
    height: 6.4rem;
    opacity: 0.6;
    color: var(--color-texts-low-contrast);
  }
}

.text {
  max-width: 70%;
  text-align: center;
  opacity: 0.6;
  margin-top: 1.6rem;
  color: var(--color-texts-low-contrast);
}
